import { render, staticRenderFns } from "./cpt-chart-column.vue?vue&type=template&id=0280b2c2&scoped=true&"
import script from "./cpt-chart-column.vue?vue&type=script&lang=js&"
export * from "./cpt-chart-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0280b2c2",
  null
  
)

export default component.exports